import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import country from './modules/country'
import home from './modules/home'
import file from './modules/file'
import requests from './modules/requests'
import fileShare from './modules/file-share'
import notification from './modules/notification'
import device from './modules/device'
import payment from './modules/payment'
import account from './modules/account'
import subscription from './modules/subscription'
import template from './modules/template'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    country,
    home,
    file,
    requests,
    fileShare,
    notification,
    device,
    payment,
    account,
    subscription,
    template
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
